import { AuthContextInterface } from "../App";
import { VenueContextInterface } from "../components/VenueProvider/VenueProvider";
import { concessionsInterface } from "../interfaces/concessions";
import { querie_object_interface } from "../interfaces/Core/Queries";
import { THEME_STORAGE_KEY } from "../constants/theme";

export const saveContext = async (
  context: AuthContextInterface,
): Promise<void> => {
  localStorage.setItem("context", JSON.stringify(context));
  return Promise.resolve();
};

export const getContext = (): AuthContextInterface | null => {
  const contextString = localStorage.getItem("context");

  if (contextString !== null) {
    const context = JSON.parse(contextString);
    return context;
  }

  return null;
};

export const saveConcessionSelected = (
  concession: concessionsInterface | null,
) => {
  localStorage.setItem("concession", JSON.stringify(concession));
};

export const getConcessionSelected = (): concessionsInterface | null => {
  const contextString = localStorage.getItem("concession");

  if (contextString !== null && contextString !== undefined) {
    const context = JSON.parse(contextString);
    return context;
  }

  return null;
};

export const saveVenueContext = (context: VenueContextInterface) => {
  localStorage.setItem("venueContext", JSON.stringify(context));
};

export const getVenueContext = (): VenueContextInterface | null => {
  const contextString = localStorage.getItem("venueContext");

  if (contextString !== null) {
    const context = JSON.parse(contextString);
    return context;
  }

  return null;
};

export const saveQuerieParams = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export const getQuerieParams = (
  key: string,
): querie_object_interface | null => {
  const querieValues = localStorage.getItem(key);

  if (querieValues !== null) {
    const value = JSON.parse(querieValues);

    return value;
  }
  return null;
};

export const changeUserSessionStorage = () => {
  for (const property in localStorage) {
    if (
      property !== "context" &&
      property !== "concession" &&
      property !== "venueContext" &&
      !property.startsWith("explorePanelFavorites")
    )
    localStorage.removeItem(property);
  }
};

export const saveHomeState = (value: string) => {
  localStorage.setItem("home", value);
};

export const getHomeState = () => {
  const homeState = localStorage.getItem("home");
  if (homeState !== null) {
    const value = JSON.parse(homeState);
    return value;
  }
  return null;
};

/**
 * Clear stored state on sign out, keeping the theme preference.
 *
 * The theme is a preference of the device rather than of the session, so it has
 * to outlive signing out the same way it outlives closing the tab.
 */
export const clearStorage = (): void => {
  try {
    const theme: string | null = localStorage.getItem(THEME_STORAGE_KEY);
    localStorage.clear();
    if (theme !== null) {
      localStorage.setItem(THEME_STORAGE_KEY, theme);
    }
  } catch (error) {
    console.warn("Could not clear the stored session", error);
  }
};
